import { render } from "./MerchantTerms.vue?vue&type=template&id=5bb81aa2"
import script from "./MerchantTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantTerms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/MerchantTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bb81aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bb81aa2', __exports__)) {
    api.reload('5bb81aa2', __exports__)
  }
  
  module.hot.accept("./MerchantTerms.vue?vue&type=template&id=5bb81aa2", () => {
    api.rerender('5bb81aa2', render)
  })

}


export default __exports__